import { render, staticRenderFns } from "./ProductDetails-salesman.vue?vue&type=template&id=5249af3a"
import script from "./ProductDetails-salesman.vue?vue&type=script&lang=js"
export * from "./ProductDetails-salesman.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails-salesman.vue?vue&type=style&index=0&id=5249af3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports